import { useState } from "react";
import Image, { ImageProps } from "next/image";

export default function Screenshot({
  cropped,
  caption,
  ...props
}: { cropped?: boolean; caption?: string } & ImageProps) {
  const [zoomed, setZoomed] = useState(false);
  return (
    <figure
      onClick={() => setZoomed((z) => !z)}
      className={zoomed ? "is-zoomed" : cropped ? "cropped" : undefined}
    >
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      <Image
        {...props}
        placeholder="blur"
        objectFit="contain"
        objectPosition="center"
      />
      {caption && (
        <figcaption>
          <span>{caption}</span>
        </figcaption>
      )}
      <style jsx>{`
        figure {
          line-height: 0;
          align-self: center;
          cursor: zoom-in;
        }
        figcaption {
          display: none;
          left: 0;
          bottom: 0;
          right: 0;
          opacity: 0;
          transition: 0.25s opacity ease-in-out;
        }
        figcaption span {
          margin-inline: auto;
          text-align: center;
          color: #494e5a;
          font-weight: bold;
          display: block;
        }
        figure :global(img) {
          border-radius: 8px;
          border: 1px solid rgba(0, 0, 0, 0.0625) !important;
        }
        figure.is-zoomed {
          position: fixed;
          z-index: 9999;
          inset: 0;
          display: grid;
          grid-template-rows: 1fr auto;
          align-items: center;
          justify-content: center;
          gap: max(24px, 5vh);
          background-color: rgba(255, 255, 255, 0.75);
          cursor: zoom-out;
          max-width: 100vw !important;
          max-height: 100vh !important;
          padding: clamp(16px, 10vh, 32px) max(24px, 4vw)
            clamp(16px, 10vh, 32px);
        }
        figure.is-zoomed > :global(span) {
          max-height: 100%;
          filter: drop-shadow(0px 30px 60px rgba(50, 50, 93, 0.25))
            drop-shadow(0px 18px 36px rgba(0, 0, 0, 0.3)) !important;
        }
        figure.is-zoomed :global(img) {
          border: 0 !important;
        }
        @supports (backdrop-filter: saturate(180%) blur(8px)) or
          (-webkit-backdrop-filter: saturate(180%) blur(8px)) {
          figure.is-zoomed {
            -webkit-backdrop-filter: saturate(180%) blur(8px);
            backdrop-filter: saturate(180%) blur(8px);
          }
        }
        @media (min-width: 520px) {
          figure {
            padding: 24px;
          }
        }
        @media (min-width: 820px) {
          figure :global(img) {
            border-radius: 16px;
            border: 1px solid rgba(0, 0, 0, 0.0625) !important;
          }
          figure.is-zoomed figcaption {
            display: block;
            opacity: 1;
          }
        }
        figure.cropped {
          padding-bottom: 0;
        }
        figure.cropped :global(img) {
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          border-bottom: 0 !important;
        }
      `}</style>
    </figure>
  );
}
